import { Button } from "@mui/material";
import { useConfig } from "../config/configContext";
import { Room } from "../config/parsedConfig";
import { useCurrentSession } from "../hooks/useCurrentSession";
import { convertSecondsToDurationString } from "../utils/time";

export const RoomButton = ({ room }: { room: Room }) => {
    const {
        currentSession,
        currentSessionTimeLeft,
        timeUntilUpcomingSession
    } = useCurrentSession(room);

    return (
        <>
            <Button
                variant={currentSession ? 'contained' : 'outlined'}
                color={room.color as any}
                size='large'
                fullWidth={true}
                onClick={() => window.location.href = `/room/${room.name}`}
                sx={{ mb: 1 }}
            >
                <div>{room.displayName}</div>
                <div className="info">
                    {currentSession
                        ? <>
                            {currentSession.name} 🖊️<br />(noch {convertSecondsToDurationString(currentSessionTimeLeft)})
                        </>
                        : <>
                            Pause 🍵<br />(noch {convertSecondsToDurationString(timeUntilUpcomingSession)})
                        </>
                    }
                </div>
            </Button>
        </>
    );
}

export const RoomList = () => {
    const { rooms } = useConfig();

    return (
        <div className="responsive roomlist">
            <div style={{ width: "100%", marginBottom: 20, paddingBottom: 20, borderBottom: "2px solid black" }}>
                <Button
                    variant="contained"
                    color={"twa-black" as any}
                    size='large'
                    fullWidth={true}
                    onClick={() => window.location.href = `/timer`}
                >
                    Individueller Timer
                </Button>
            </div>

            {Object.values(rooms).map(room => (
                <RoomButton key={room.name} room={room} />
            ))}
        </div>
    );
};
